import {
  validateErrors,
  required,
  maxLength,
} from '../validators';


const validate = (values) => {
  const validators = {
    promo: [maxLength(30), required],
  };
  return validateErrors(values, validators);
};

export default validate;
